import { theme } from 'antd';
import { UserIcon } from 'assets/images/svg';
import { formatDisplayName } from 'library/helpers/utility';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPeople } from 'reduxStore/people/selectors';
import { selectTeamsByTeamID } from 'reduxStore/teams/selectors';
import { Loader } from 'zComponents/atoms';
import PersonDrawer from 'zComponents/molecules/PersonDrawer';
import { Empty, Flex, Space, Tag } from 'zui/Antd';

const MembersPanelContent = ({ teamID }) => {
	const {
		token: { fontWeightStrong, paddingSM, paddingXXS }
	} = theme.useToken();

	// ✅ Select team and people from redux
	const team = useSelector((state) => selectTeamsByTeamID(state, teamID));
	const people = useSelector(selectPeople);
	const { loadingAddMembersTeam, deleteTeamMemberLoading } = useSelector((state) => state.Teams);

	const [selectedPersonID, setSelectedPersonID] = useState(null);
	const [openPeopleDrawer, setOpenPeopleDrawer] = useState(false);

	const members = people.filter((person) => team?.members?.includes(person.personID)) || [];

	// ✅ Remove member
	if (loadingAddMembersTeam || deleteTeamMemberLoading) {
		return (
			<>
				<Flex justify='center' align='start' style={{ width: '100%' }}>
					<Loader />
				</Flex>
			</>
		);
	}

	if (members.length === 0) {
		return (
			<>
				<Flex justify='center' align='start' style={{ width: '100%' }}>
					<Empty description='No members' image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</Flex>
			</>
		);
	}

	return (
		<>
			<Space wrap size={paddingSM}>
				{members.map((member) => (
					<Tag
						key={member.personID}
						color='purple'
						style={{
							fontWeight: fontWeightStrong,
							borderColor: 'currentColor',
							cursor: 'pointer',
							marginInlineEnd: 0
						}}
						onClick={() => {
							setSelectedPersonID(member.personID);
							setOpenPeopleDrawer(true);
						}}
					>
						<Flex align='center' gap={paddingXXS}>
							<UserIcon color='currentColor' />
							{formatDisplayName(member).displayName}
						</Flex>
					</Tag>
				))}
			</Space>
			<PersonDrawer visible={openPeopleDrawer} setVisible={setOpenPeopleDrawer} personID={selectedPersonID} />
		</>
	);
};

export default MembersPanelContent;
